import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasGetafe() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Getafe, Madrid</h1>
        <span className={styles.lastUpdated}>Mudanzas rápidas y seguras en Getafe y zona sur de Madrid</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/distrito-getafe.webp"
            alt="Mudanzas en Getafe"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          Britosa Mudanzas es la empresa de referencia para <strong>mudanzas en Getafe</strong>. Desde nuestra base en Móstoles, llegamos a cualquier punto de Getafe en pocos minutos, lo que nos permite ofrecer precios competitivos y tiempos de respuesta inmejorables.
        </p>

        <h2>Servicios de mudanza en Getafe</h2>
        <p>
          Getafe es una ciudad dinámica con gran demanda de servicios de mudanza. Tanto si te mudas dentro del municipio como si llegas o sales de Getafe, en Britosa tenemos la solución perfecta para ti.
        </p>
        <ul>
          <li><strong>Mudanzas locales:</strong> Dentro de Getafe o hacia Madrid, Móstoles, Alcorcón, Leganés y Fuenlabrada.</li>
          <li><strong>Mudanzas de pisos:</strong> Estudios, áticos y viviendas familiares en cualquier zona de Getafe.</li>
          <li><strong>Mudanzas de empresas:</strong> Oficinas, locales comerciales y naves industriales.</li>
          <li><strong>Guardamuebles:</strong> Almacenamiento seguro para tus pertenencias.</li>
          <li><strong>Embalaje profesional:</strong> Materiales de primera calidad para proteger tus objetos.</li>
        </ul>

        <h2>Zonas de Getafe que cubrimos</h2>
        <p>
          Centro, San Isidro, Juan de la Cierva, Las Margaritas, El Bercial, Sector III, Alhóndiga, Getafe Norte, Los Molinos y todas las zonas industriales y residenciales del municipio.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Presupuesto gratis para Getafe</h3>
          <p style={{ marginBottom: "1rem" }}>
            Solicita tu presupuesto sin compromiso. Precios competitivos por cercanía a Móstoles.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          <a href="tel:+34691604880">691 60 48 80</a> · <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a>
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Getafe",
          "description": "Mudanzas rápidas y seguras en Getafe, Madrid. Precios competitivos desde Móstoles.",
          "url": "https://mudanzasbritosa.com/mudanzas-getafe",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero, 28934 Móstoles",
            "addressLocality": "Getafe, Madrid",
            "addressRegion": "Madrid",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.3083,
            "longitude": -3.7327
          },
          "areaServed": {
            "@type": "City",
            "name": "Getafe"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );
}
